<template>
  <div class="room-create">
    <div class="mtitle">{{classesInfo.classesName}}</div>
    <div class="content">
      <div class="mleft">
        <div class="local-live" id="localStream"></div>
        <div class="frce btns">
          <!--<el-button type="primary">全体禁言</el-button>-->
          <el-button :type="audioSelfFlag ? 'primary' : 'danger'" @click="closeAudioSelf">{{audioSelfFlag ? "禁麦" :
            "开麦"}}</el-button>
          <el-button type="primary" @click="chatStatusTap">{{ chatStatus== 'true' ? '全体禁言' : '关闭禁言'}}</el-button>
          <el-button type="primary" @click="openCameraTap">开启视频</el-button>
          <el-button type="primary" @click="shareScreenTap">共享屏幕</el-button>
          <el-button type="primary" @click="changeAudioTap">切换音频源</el-button>
          <el-button type="primary" v-if="classesInfo.materialsUrl" v-on:click="openFile(classesInfo.materialsUrl)">课程资料</el-button>
          <el-button type="danger" @click="roomEnd">结束直播</el-button>
        </div>
      </div>
      <div class="chat-area">
        <ul class="tabbar">
          <li :class="tbIndex == 0 ? 'tb-itemb' : 'tb-itema'" @click="tabBarTap(0)">聊天</li>
          <li :class="tbIndex == 1 ? 'tb-itemb' : 'tb-itema'" @click="tabBarTap(1)">人员</li>
        </ul>
        <template v-if="tbIndex == 0">
          <ul class="show-area">
            <template v-for="item in liveMessage">
              <li class="sa-item">
                <img class="icon-c" src="@/assets/avator11.png" alt="">
                <div>
                  <p><span class="text-b">{{item.userName}}</span> <span class="text-c">{{item.time}}</span></p>
                  <p class="text-d">{{item.content}}</p>
                </div>
              </li>
            </template>
          </ul>
          <div class="input-area">
            <el-input type="textarea" resize="none" rows="3" v-model="message"></el-input>
            <div class="frce btnsb">
              <el-button type="primary" @click="submitFormMsg">发送</el-button>
            </div>
          </div>
        </template>
        <template v-if="tbIndex == 1">
          <div class="musers">
            <p>
              <span>在线人数：</span><span style="color: #3d6fd8">{{onlineStudent}}</span>
              <span style="margin-left: 20px">实际人数：</span><span style="color: #3d6fd8">{{totalStudent}}</span>
            </p>
            <ul class="mmusers">
              <template v-for="(item, index) in liveRoomStudentVOList">
                <li :class="item.onlineFlag ? 'item-b' : 'item'" @click="closeAudioStudent(index)">
                  <img class="img-a" :src="item.avatar | fileFilter" alt="">
                  <span class="text-g">{{item.nickName}}</span>
                  <img v-if="item.auditFlag" class="img-b" src="@/assets/iconc01.png" alt="">
                  <img v-else class="img-b" src="@/assets/iconc02.png" alt="">
                </li>
              </template>
            </ul>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
  import TRTCUtilTeacher from "@/utils/TRTCUtilTeacher";
  import HttpConnectionB from "@/utils/HttpConnectionB";
  import CommonFilters from "@/mixins/CommonFilters";
  import WebSocketUtil from "@/utils/WebSocketUtil";
  let teacherHeartInterval = null;
  export default {
    name: "RoomCreate",
    mixins: [CommonFilters],
    data () {
      return {
        message: "",
        classesInfo: {},
        adminTime: "",
        tbIndex: 0,
        onlineStudent: 0,
        totalStudent: 0,
        liveRoomStudentVOList: [],
        audioSelfFlag: true,
        chatStatus: 'true',
        trackSourceConfig: ["audio", "video"]
      };
    },
    computed: {
      liveMessage () {
        return this.$store.state.app.liveMessage;
      }
    },
    mounted () {
      let that = this;
      let _classInfo = sessionStorage.getItem("classInfo");
      that.classesInfo = JSON.parse(_classInfo);
      that.roomCreate();
      that.getLiveUser();
      this.getStatus();
      // teacherHeartInterval = setInterval(function() {that.getLiveUser();}, 10000);
    },
    methods: {
      roomCreate () {
        let that = this;
        that.HttpConnection.post("/rtc/room/create", {
          roomInfo: that.classesInfo.classesName,
          scheduleId: that.classesInfo.scheduleId
        }).then(function (response) {
          TRTCUtilTeacher.loginTRTC("localStream", response.data);
        });
      },
      getLiveUser () {
        let that = this;
        HttpConnectionB.get("/rtc/room/live/student/list", {
          params: {
            classId: that.classesInfo.classId
          }
        }).then(function (response) {
          that.onlineStudent = response.data.onlineStudent;
          that.totalStudent = response.data.totalStudent;
          that.liveRoomStudentVOList = response.data.liveRoomStudentVOList;
        });
      },
      submitFormMsg () {
        let that = this;
        let _userInfo = this.$store.state.user.userInfo;
        HttpConnectionB.post("/chat/real-time/send-class", {
          cmd: 0,
          classId: that.classesInfo.classId,
          teacherId: _userInfo.userId,
          teacherName: _userInfo.nickName,
          scheduleId: that.classesInfo.scheduleId,
          content: that.message
        }).then(function (response) {
          that.message = "";
        });
      },
      tabBarTap (index) {
        this.tbIndex = index;
      },
      roomEnd () {
        // this.$router.back(-1);
        this.$router.push({
          path: "/ManageEducation/TeacherSchedule"
        });
      },
      /*
      * 切换音频源
      * */
      changeAudioTap () {
        let _sourceTrackConfig = {};
        if (this.trackSourceConfig[0] == "audio" && this.trackSourceConfig[1] == "screen") {
          this.trackSourceConfig[0] = "screenAudio";
          _sourceTrackConfig[this.trackSourceConfig[0]] = true;
          _sourceTrackConfig[this.trackSourceConfig[1]] = true;
          TRTCUtilTeacher.changeTrackSource(_sourceTrackConfig);
        } else if (this.trackSourceConfig[0] == "screenAudio" && this.trackSourceConfig[1] == "video") {
          this.trackSourceConfig[0] = "audio";
          _sourceTrackConfig[this.trackSourceConfig[0]] = true;
          _sourceTrackConfig[this.trackSourceConfig[1]] = true;
          TRTCUtilTeacher.changeTrackSource(_sourceTrackConfig);
        }
      },
      /*
      * 共享屏幕
      * */
      shareScreenTap () {
        let _userId = WebSocketUtil.getStudentUserId();
        WebSocketUtil.sendWebSocket({ cmd: 4, userId: _userId });

        this.trackSourceConfig[1] = "screen";
        let _sourceTrackConfig = {};
        _sourceTrackConfig[this.trackSourceConfig[0]] = true;
        _sourceTrackConfig[this.trackSourceConfig[1]] = true;
        TRTCUtilTeacher.changeTrackSource(_sourceTrackConfig);
      },
      /*
      * 开启视频
      * */
      openCameraTap () {
        let _userId = WebSocketUtil.getStudentUserId();
        WebSocketUtil.sendWebSocket({ cmd: 4, userId: _userId });

        this.trackSourceConfig[0] = "audio";
        this.trackSourceConfig[1] = "video";
        let _sourceTrackConfig = {};
        _sourceTrackConfig[this.trackSourceConfig[0]] = true;
        _sourceTrackConfig[this.trackSourceConfig[1]] = true;
        TRTCUtilTeacher.changeTrackSource(_sourceTrackConfig);
      },
      /*
      * 禁学员麦
      * */
      closeAudioStudent (index) {
        let _userId = this.liveRoomStudentVOList[index].userId;
        let audioFlag = this.liveRoomStudentVOList[index].auditFlag;
        if (audioFlag) {
          WebSocketUtil.sendWebSocket({
            cmd: 1,
            userId: _userId
          });
        } else {
          WebSocketUtil.sendWebSocket({
            cmd: 2,
            userId: _userId
          });
        }
        this.liveRoomStudentVOList[index].auditFlag = !this.liveRoomStudentVOList[index].auditFlag;
      },
      /*
      * 关闭自己的麦
      * */
      closeAudioSelf () {
        if (this.audioSelfFlag) {
          TRTCUtilTeacher.setMuteAudio();
        } else {
          TRTCUtilTeacher.setUnmuteAudio();
        }
        this.audioSelfFlag = !this.audioSelfFlag;
      },
      // 切换禁言状态
      chatStatusTap () {
        let that = this;
        if (that.chatStatus == 'true') {
          that.chatStatus = 'false'
        } else {
          that.chatStatus = 'true'
        }
        HttpConnectionB.post("/rtc/room/change/chat/status", {
          classId: that.classesInfo.classId,
          chatStatus: that.chatStatus
        }).then(res => {

        })
      },
      // 获取禁言状态
      getStatus () {
        let that = this;
        HttpConnectionB.get("/rtc/room/chat/status", {
          params: {
            classId: that.classesInfo.classId,
          }
        }).then(res => {
          that.chatStatus = res.msg
        })
      },
      openFile(url){
        sessionStorage.setItem('fileUrl',`${process.env.VUE_APP_imagePath}${url}`)
        window.open(`/build/generic/web/viewer.html`) 
      }
    },

    beforeDestroy () {
      TRTCUtilTeacher.logoutTRTC();
      clearInterval(teacherHeartInterval);
    }
  };
</script>

<style scoped lang="scss">
  .room-create {
    width: 100vw;
    height: 100vh;
    overflow: hidden;
  }

  .mtitle {
    height: 4vh;
    line-height: 4vh;
    text-align: center;
    background-color: #f4f8fb;
  }

  .content {
    height: 94vh;
    display: flex;
    flex-direction: row;
  }

  .mleft {
    width: 80vw;
    height: 94vh;
    padding: 1vw;
  }

  .chat-area {
    width: 20vw;
    height: 94vh;
    border-left: 1px solid #E6E6E6;

    .show-area {
      height: 72vh;
      padding: 1vh;
      overflow-y: scroll;

      .sa-item {
        display: flex;
        flex-direction: row;
        margin: 6px 0px 0px 0px;
      }
    }

    .input-area {
      border-top: 1px solid #E6E6E6;
      padding: 1vh;
      margin-top: 1vh;
    }

    .tabbar {
      height: 4vh;
      display: flex;
      flex-direction: row;
      align-items: center;
      border-bottom: 1px solid #E6E6E6;
    }

    .tb-itema {
      padding: 0px 10px;
      cursor: pointer;
      color: #000409;
    }

    .tb-itema:hover {
      color: #3d6fd8;
    }

    .tb-itemb {
      padding: 0px 10px;
      cursor: pointer;
      color: #3d6fd8;
    }

    .musers {
      height: 74vh;
      padding: 1vh;
    }

    .mmusers {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;

      .item {
        margin: 10px;
        cursor: pointer;
        position: relative;
        border: 1px solid #FFFFFF;
        display: flex;
        flex-direction: column;
        align-content: center;
        justify-content: center;
        padding: 4px 10px 4px 10px;
      }

      .item-b {
        margin: 10px;
        cursor: pointer;
        position: relative;
        border: 1px solid #27f306;
        display: flex;
        flex-direction: column;
        align-content: center;
        justify-content: center;
        padding: 4px 10px 4px 10px;
      }
    }
  }

  .local-live {
    width: 78vw;
    height: 85vh;
    overflow: hidden;
  }

  .btns {
    width: 78vw;
    margin-top: 1vh;
  }

  .btnsb {
    margin-top: 1.2vh;
  }

  .icon-c {
    width: 36px;
    height: 36px;
    margin-right: 8px;
  }

  .text-b {
    font-size: 12px;
    font-weight: 400;
    color: #666666;
  }

  .text-d {
    width: 213px;
    font-size: 14px;
    font-weight: 400;
    line-height: 18px;
    color: #FFFFFF;
    background-color: #91A9FF;
    padding: 7px;
    border-radius: 4px;
    margin: 4px 0px 0px 0px;
  }

  .text-c {
    font-size: 12px;
    font-weight: 400;
    color: #999999;
  }

  .text-g {
    font-size: 12px;
    color: #333333;
    text-align: center;
  }

  .img-a {
    width: 32px;
    height: 32px;
    border-radius: 16px;
  }

  .img-b {
    width: 24px;
    height: 24px;
    position: absolute;
    bottom: 0px;
    right: -10px;
  }
</style>